module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// D:/midea_porject/php/htdocs/~/core-js/library/modules/$.add-to-unscopables.js
// module id = 50
// module chunks = 0